
















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import omegaup_OverlayPopup from '../OverlayPopup.vue';
import { AvailableViews } from './DemotionPopup.vue';
import T from '../../lang';

interface DifficultyLevel {
  id: number;
  description: string;
}

interface QualityLevel {
  id: number;
  description: string;
}

@Component({
  components: {
    'omegaup-overlay-popup': omegaup_OverlayPopup,
  },
})
export default class QualityPromotionPopup extends Vue {
  @Prop({ default: false }) solved!: boolean;
  @Prop({ default: false }) tried!: boolean;
  @Prop({
    default: () => [
      { id: '0', description: T.qualityFormDifficultyVeryEasy },
      { id: '1', description: T.qualityFormDifficultyEasy },
      { id: '2', description: T.qualityFormDifficultyMedium },
      { id: '3', description: T.qualityFormDifficultyHard },
      { id: '4', description: T.qualityFormDifficultyVeryHard },
    ],
  })
  difficultyLevels!: DifficultyLevel[];
  @Prop({
    default: () => [
      { id: '0', description: T.qualityFormQualityVeryBad },
      { id: '1', description: T.qualityFormQualityBad },
      { id: '2', description: T.qualityFormQualityFair },
      { id: '3', description: T.qualityFormQualityGood },
      { id: '4', description: T.qualityFormQualityVeryGood },
    ],
  })
  qualityLevels!: QualityLevel[];

  AvailableViews = AvailableViews;
  T = T;
  currentView: AvailableViews = AvailableViews.Content;
  difficulty = '';
  quality = '';

  onCloseModal(currentView: AvailableViews): void {
    if (currentView !== AvailableViews.Thanks) {
      this.onDismiss();
      return;
    }
    this.onHide(false);
  }

  onHide(isDismissed: boolean): void {
    this.$emit('dismiss', this, isDismissed);
  }

  onDismiss(): void {
    this.$emit('dismiss', this, /*isDismissed=*/ true);
  }

  onSubmit(): void {
    this.$emit('submit', {
      solved: this.solved,
      tried: this.tried,
      difficulty: this.difficulty,
      quality: this.quality,
    });
    this.currentView = AvailableViews.Thanks;

    setTimeout(() => this.onHide(false), 2000);
  }
}
